import { AppState } from 'Store'

const getAll = (state: AppState) => state.modules.fms.fmsUnits

export const fmsSelectors = {
	getAll,
}
